module.exports = __webpack_public_path__ + "img/more-w.661210b.svg";